/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import LoginErrorModal from './LoginErrorModal';
import { openLoginErrorModal, selectLogin } from './userSlice';
import { useAuth } from './useHooks';
import { analyticsTrack } from '../analytics_utils';

const LoginErrorComponent = ({ error }: { error?: Error }) => {
  const login = useAppSelector(selectLogin);
  const { logout } = useAuth();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (error) {
      analyticsTrack(
        'login_failed',
        {
          title: 'Okta Error',
          description: `${error.message || (error as any).errorSummary} ${
            (error as any).error ? `(Error code: ${(error as any).error})` : ''
          }`,
        },
        undefined
      );
      dispatch(
        openLoginErrorModal({
          errors: [
            {
              title: 'Okta Error',
              detail: `${error.message || (error as any).errorSummary} ${
                (error as any).error ? `(Error code: ${(error as any).error})` : ''
              }`,
            },
          ],
          errorModalOpen: true,
          fromSmartFhirCookie: false,
          fromShareVueCookie: false,
        })
      );
    }
  }, [dispatch, error]);
  // Log the user out of okta when closing the modal since pearl auth failed
  return <LoginErrorModal login={login} onClose={logout} />;
};

export default LoginErrorComponent;
